import { render, staticRenderFns } from "./Datapoint.vue?vue&type=template&id=5bb18104&scoped=true"
import script from "./Datapoint.vue?vue&type=script&lang=js"
export * from "./Datapoint.vue?vue&type=script&lang=js"
import style0 from "./Datapoint.vue?vue&type=style&index=0&id=5bb18104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb18104",
  null
  
)

export default component.exports